import { Stack, Typography } from "@mui/material";

export const LabelTab = ({ name, isRequired }: any) => (
  <Stack
    alignItems="flex-start"
    direction="column"
  >
    <Typography variant="button">
      {name}
    </Typography>
    <Typography variant="caption" color="GrayText">
      {isRequired && 'Required'}
    </Typography>
  </Stack>
);